/**
 * Shared visual tokens.
 *
 * Their own module on purpose. They previously lived in App.jsx, which made
 * ImportView import from App while App imported ImportView — a cycle Rollup
 * resolved by silently dropping the whole subtree from the bundle. The build
 * still reported success; the app just wasn't in it.
 */
export const T = {
  bg: "#F2EBDC",
  panel: "#FFFFFF",
  panelSoft: "#FAF6EC",
  ink: "#1A1815",
  muted: "#7A7468",
  border: "#DDD3BE",
  borderSoft: "#E9E1D0",
  accent: "#2F5D41",
  accentSoft: "#DDE8DF",
  income: "#2F5D41",
  cost: "#8C2A2A",
  warn: "#8A6A1F",
  // Pipeline income: distinct from invoiced money on purpose. A quote and an
  // invoice are different kinds of certainty and should not share a colour.
  pipeline: "#5B4B8A",
  // Overdue marker. Amber rather than the cost red, which already means
  // "money out" — reusing it would make every cost look late.
  overdue: "#B5651D",
  overdueSoft: "#FBEFE2",
  // Money confirmed in the bank. A filled background rather than another text
  // colour: "it landed" is a different kind of fact from "how much", and should
  // be readable without comparing shades.
  received: "#2F7D4F",
  receivedSoft: "#DFF0E3",
  // Money already paid out. Deliberately NOT red and NOT green: red is reserved
  // for "you are below the overdraft", which must stay the loudest thing on the
  // page, and green would read as good news when a payment leaving is merely
  // settled. Neutral says "this has happened" without arguing either way.
  settled: "#6B6558",
  settledSoft: "#E8E3D6",
};

export const fontDisplay = `'Fraunces', Georgia, serif`;
export const fontMono = `'JetBrains Mono', ui-monospace, monospace`;
